import { AppBar, Box, Stack, Toolbar } from '@mui/material';

import { MainLogo } from './logo';
import { AlertSidePanel } from './alert-panel';
import { MainMenu } from './menu';
import { UserOrganizationSelector } from './org-selector';
import { UserProfileDropdown } from './profile';
import { SearchBar } from './searchbar';
import { LearnSiloReal } from './learn-silo-real';
import { AdministratorIconComponent } from './administrator';
import { AIAssistantIconComponent } from './ai-assistant';
import { useEffect, useRef, useState } from 'react';

import i18n from '../../libs/language';
import { useConnection } from '@old/hooks/use-connection';
import { useGlobalStore } from '@old/global-store/use-store';

import { useLocation, useNavigate } from 'react-router';
import { PATH } from '@old/data/core/paths';
import { ReportSatelitalModal } from '@old/features/silobags/report-satelital-modal/report-satelital-moda';

export function GlobalNav() {
  const [openReportSat, setOpenReportSat] = useState(false);
  useEffect(() => {
    const storedName = localStorage.getItem('LANGUAGE_PREFERENCE');
    if (storedName) {
      i18n.locale = storedName;
    }
  }, []);

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const handleResize = () => {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const isOnline = useConnection();

  const email = useGlobalStore.getState().email;
  const navigate = useNavigate();
  const location = useLocation();
  const previousPathRef = useRef(`${location.pathname}${location.search}${location.hash}`);
  const wasOfflineRef = useRef(false);

  useEffect(() => {
    if (!isOnline) {
      previousPathRef.current = `${location.pathname}${location.search}${location.hash}`;
      wasOfflineRef.current = true;
      navigate(PATH.NO_CONNECTION);
    } else if (email && wasOfflineRef.current) {
      wasOfflineRef.current = false;
      navigate(previousPathRef.current);
    } else if (!email) {
      navigate(PATH.LOGIN);
    }
  }, [isOnline]);

  return (
    <>
      <Box>
        <AppBar
          component="header"
          position="static"
          elevation={0}
          sx={{
            color: '#000',
            backgroundColor: '#FFF',
            height: '64px',
            borderBottom: '1px solid #ccc',
            paddingRight: { xs: 0, md: '15px' },
          }}
        >
          <Toolbar disableGutters sx={{ padding: '0 20px' }}>
            {windowSize.width > 1025 ? (
              <Stack direction="row" spacing={2} alignItems="center" width="100%">
                <MainLogo />
                <SearchBar />
                <UserOrganizationSelector />
                <MainMenu setOpenReportSat={setOpenReportSat} />
                <AIAssistantIconComponent />
                <AlertSidePanel />
                <AdministratorIconComponent />
                <LearnSiloReal />
                <UserProfileDropdown />
              </Stack>
            ) : (
              <Stack direction="row" spacing={2} width="100%" alignItems="center">
                <MainLogo />
                <SearchBar isMobile />
                <AlertSidePanel />
                <UserProfileDropdown isMobile setOpenReportSat={setOpenReportSat} />
              </Stack>
            )}
          </Toolbar>
        </AppBar>
      </Box>
      {openReportSat && <ReportSatelitalModal open={openReportSat} setOpen={setOpenReportSat} />}
    </>
  );
}
